import { BehaviorSubject } from "rxjs";

interface SwState {
  updateAvailable: boolean;
}

const state$ = new BehaviorSubject<SwState>({ updateAvailable: false });
let waitingWorker: ServiceWorker | null = null;

export const swStatus = {
  state$: state$.asObservable(),

  applyUpdate(): void {
    if (!waitingWorker) {
      window.location.reload();
      return;
    }
    waitingWorker.postMessage("SKIP_WAITING");
  },
};

function trackWaiting(reg: ServiceWorkerRegistration): void {
  const worker = reg.waiting;
  if (worker && navigator.serviceWorker.controller) {
    waitingWorker = worker;
    state$.next({ updateAvailable: true });
  }
}

export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js");

      trackWaiting(reg);

      reg.addEventListener("updatefound", () => {
        const installing = reg.installing;
        if (!installing) return;
        installing.addEventListener("statechange", () => {
          if (
            installing.state === "installed" &&
            navigator.serviceWorker.controller
          ) {
            waitingWorker = installing;
            state$.next({ updateAvailable: true });
          }
        });
      });

      navigator.serviceWorker.addEventListener("controllerchange", () => {
        window.location.reload();
      });
    } catch (err) {
      console.error("[sw] registration failed:", err);
    }
  });
}
